import { Loader } from '@mantine/core';

export function DataTreeLoader() {
	return <Loader size={12} ml="xl" my="xs" />;
}
